import { filterAllBoletos, getAllBoletos, saveBoleto, updateBoleto, deleteBoleto } from '@/services/api/boleto.js';
export const actions = {
  async getBoletosByFilter(state, filter) {
    try {
      const dataList = await filterAllBoletos(filter);
      state.commit('SET_LIST', dataList);
      return dataList;
    } catch (error) {
      state.dispatch(
        'modal/showModal',
        {
          title: 'Erro ao processar a requisição!',
          message: 'Se o problema persistir, favor contatar o suporte.',
          buttonText: 'VOLTAR',
        },
        {
          root: true,
        }
      );
    }
  },
  async deleteBoleto(state, payload) {
    try {
      await deleteBoleto(payload);
    } catch (error) {
      /* eslint-disable */
      console.log(error)
      state.dispatch(
        'modal/showModal',
        {
          title: 'Cadastro Atualizado',
          message: `Editado com sucesso.`,
          buttonText: 'FECHAR',
        },
        {
          root: true,
        }
      );
    }
  },
  async getAllBoletos(state) {
    try {
      const dataList = await getAllBoletos();
      state.commit('SET_LIST', dataList);
      return dataList;
    } catch (error) {
      state.dispatch(
        'modal/showModal',
        {
          title: 'Erro ao processar a requisição!',
          message: 'Se o problema persistir, favor contatar o suporte.',
          buttonText: 'VOLTAR',
        },
        {
          root: true,
        }
      );
    }
  },
  async saveBoleto(state, payload) {
    try {
      await saveBoleto(payload);
    } catch (error) {
      state.dispatch(
        'modal/showModal',
        {
          title: 'Erro ao processar a requisição!',
          message: 'Se o problema persistir, favor contatar o suporte.',
          buttonText: 'VOLTAR',
        },
        {
          root: true,
        }
      );
    }
  },
  async updateBoleto(state, payload) {
    try {
      await updateBoleto(payload);
    } catch (error) {
        /* eslint-disable */
      console.log(error)
      state.dispatch(
        'modal/showModal',
        {
          title: 'Erro ao processar a requisição!',
          message: 'Se o problema persistir, favor contatar o suporte.',
          buttonText: 'VOLTAR',
        },
        {
          root: true,
        }
      );
    }
  }
}
